import * as React from 'react';
import * as firebase from 'firebase/app';
import { Dispatch } from 'react-redux';
import { Table, Card, Button, Popconfirm, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { AppState, Merchant, Category, TrendingCategory } from 'src/store';
import { actions as toast } from 'src/toast';
import ButtonGroup from 'antd/lib/button/button-group';
import { Subscription } from 'rxjs';
import { querySnapShot$ } from 'src/util';

const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    navigate: (route: string) => {
      dispatch(push(route));
    },
    onEdit: (id: string) => { dispatch(push(`/trendingCategories/edit/${id}`)); },
    onDelete: async (id: string) => {
      const ref = firebase.firestore().collection('trendingCategories');
      if (id) {
        const doc = ref.doc(id)
        await doc.delete()
        dispatch(toast.success('Featured Ads is deleted successfully.'));
      }
    },
  };
};

interface P {
  navigate: (route: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => Promise<void>;
}
type S = {
  status: 'none' | 'loading';
} | {
  status: 'loaded';
  data: TrendingCategory[];
}
class TrendingCategoryList extends React.Component<P, S> {
  columns: ColumnProps<TrendingCategory>[];
  subscription: Subscription;

  constructor(props: P) {
    super(props);
    this.state = { status: 'none' };
    this.subscription = new Subscription();
  }

  componentDidMount() {
    this.setState({ status: 'loading' });
    const query = firebase.firestore()
      .collection('trendingCategories')
      .orderBy("sorter")

    this.subscription = querySnapShot$(query)
      .subscribe(qsn => {
        const data = qsn.docs.map(d => ({ id: d.id, ...d.data() } as TrendingCategory));
        this.setState({ status: 'loaded', data });
      });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleOnAdd = () => {
    const { navigate } = this.props;
    navigate(`/trendingCategories/create`);
  }

  getMerchantNames = (merchants?: Merchant[]) => {
    let resultString = "";
    if (merchants && merchants.length > 0) {
      merchants.forEach(merchant => {
        resultString += merchant.businessName + ", ";
      })
      // remove the extra comma at the end, using a regex
      resultString = resultString.replace(/,(?=[^,]*$)/, '')
    }
    return resultString
  }

  getCategoryNames = (categories?: Category[]) => {
    let resultString = "";
    if (categories && categories.length > 0) {
      categories.forEach(category => {
        resultString += category.name + ", ";
      })
      // remove the extra comma at the end, using a regex
      resultString = resultString.replace(/,(?=[^,]*$)/, '')
    }
    return resultString
  }

  render() {
    const { onEdit, onDelete } = this.props;

    this.columns = [{
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: '5%',
      render: (text: string, record: TrendingCategory) => {
        return <span>{record.no}</span>;
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '10%',
    },
    {
      title: 'Merchants',
      // dataIndex: 'creat',
      width: '30%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: TrendingCategory) => {
        return <span>{this.getMerchantNames(record.merchants)}</span>;
      }
    },
    {
      title: 'Category',
      // dataIndex: 'creat',
      width: '20%',
      // tslint:disable-next-line:no-any
      render: (text: string, record: TrendingCategory) => {
        return <span>{this.getCategoryNames(record.categories)}</span>;
      }
    },
    {
      title: 'Sorter',
      dataIndex: 'sorter',
      key: 'sorter',
      width: '5%',
    },
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      width: '10%',
      render: (text: string, record: TrendingCategory) => {

        return (
          <ButtonGroup>
            <Tooltip placement="top" title="Click to edit trending category">
              <Button
                icon="edit"
                // tslint:disable-next-line:jsx-no-lambda
                onClick={() => { onEdit(record.id); }}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to delete this trending category?"
              // tslint:disable-next-line:jsx-no-lambda
              onConfirm={() => { onDelete(record.id); }}
              // onCancel={cancel} 
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement="top" title="Click to delete trending category">
                <Button icon="delete" />
              </Tooltip>
            </Popconfirm>

          </ButtonGroup>
        );
      }
    }
    ];

    const data = this.state.status === 'loaded' ? this.state.data : [];

    const dataSource = data.map((d, i) => ({
      no: i + 1,
      ...d
    }));

    return (
      <Card
        loading={this.state.status === 'loading'}
        title="Trending Category List"
        bordered={true}
        bodyStyle={{ padding: 10 }}
        extra={
          <Button type="primary" icon="plus" onClick={this.handleOnAdd}>
            Create
              </Button>
        }>
        <Table
          columns={this.columns}
          dataSource={dataSource}
          pagination={false}
          rowKey="no"
          size="middle"
          bordered={true}
        />
      </Card>
    );
  }
}

export default connect(() => ({}), mapDispatchToProps)(TrendingCategoryList);



// WEBPACK FOOTER //
// ./src/trendingCategories/containers/TrendingCategoryList.tsx